import React from "react"
import clsx from "clsx"

interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  progress: number
  height?: string
  width?: string
  color?: string
  bgColor?: string
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  className,
  progress,
  height = "h-3",
  width = "w-5",
  color = "bg-green",
  bgColor = "bg-white",
  ...props
}) => {
  return (
    <div className={clsx("rounded-full", bgColor, height, width, className)} {...props}>
      <div className={clsx("h-full z-1 rounded-full", color)} style={{ width: `${progress}%` }} />
    </div>
  )
}
